import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Option = styled.button`
  border: none;
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }
`;


// WEBPACK FOOTER //
// ./src/components/Options/Options.style.js